export default Object.freeze({
  IMAGE: 'image',
  AUDIO: 'audio',
  VIDEO: 'video',
  LINK: 'link',
  WEATHER_WIDGET: 'weather_widget',
  TEXT_WIDGET: 'text_widget'
});